import { render } from "./ColisPostaux.vue?vue&type=template&id=df09b5d0&scoped=true&ts=true"
import script from "./ColisPostaux.vue?vue&type=script&lang=ts"
export * from "./ColisPostaux.vue?vue&type=script&lang=ts"

import "./ColisPostaux.vue?vue&type=style&index=0&id=df09b5d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df09b5d0"]])

export default __exports__